<template>
  <div id="cup_recordDataOverview" v-show="currThemeObj">
    <div class="abs_topArea">数据概览</div>
    <div class="teamList_area">
      <div class="teamList_floor1">
        <html_seasonMatch
          v-if="floor1_0"
          :pareData="floor1_0"
          @clickPublishEvent="clickPublish"
        ></html_seasonMatch>
        <html_seasonGoal
          v-if="floor1_1"
          :pareData="floor1_1"
          @clickPublishEvent="clickPublish"
        ></html_seasonGoal>
        <html_seasonGoalTime
          v-if="floor1_2"
          :pareData="floor1_2"
          @clickPublishEvent="clickPublish"
        ></html_seasonGoalTime>
      </div>
      <div class="groupData_item" v-if="overview_teamDataList">
        <div class="group_label">
          <span :class="['labelTitle', 'letterSpa']" v-text="teamTitle"></span>
          <span
            class="moreBtn"
            @click="
              goMore(`recordTeamDataIndex_${currThemeObj.moduleRouteNameEn}`)
            "
            v-text="'更多数据 >'"
          ></span>
        </div>
        <cup_cardList
          :currThemeObj="currThemeObj"
          :currCid="currCid"
          :currSid="currSid"
          :list="overview_teamDataList"
          :mode="teamMode"
          @clickPublishEvent="clickPublish"
        >
          <template v-slot:overviewTeamData="{ datas }">
            <span
              class="cardItem_row"
              :class="teamMode"
              v-for="item in datas"
              :key="item.id"
              @click="
                goDetail(
                  `teamDetailIndex_${currThemeObj.moduleRouteNameEn}`,
                  item
                )
              "
            >
              <span class="rankNo" v-text="item.rank"></span>
              <span class="cardItem_row_image">
                <img :src="item.imageUrl" />
              </span>
              <span class="cardItem_row_name" v-text="item.shortName"></span>
              <span class="cardItem_row_val" v-text="item.val"></span>
            </span>
          </template>
        </cup_cardList>
      </div>
      <div class="groupData_item" v-if="overview_playerDataList">
        <div class="group_label">
          <span
            :class="['labelTitle', 'letterSpa']"
            v-text="playerTitle"
          ></span>
          <span
            class="moreBtn"
            @click="
              goMore(`recordPlayerDataIndex_${currThemeObj.moduleRouteNameEn}`)
            "
            v-text="'更多数据 >'"
          ></span>
        </div>
        <cup_cardList
          :currThemeObj="currThemeObj"
          :currCid="currCid"
          :currSid="currSid"
          :list="overview_playerDataList"
          :mode="playerMode"
          @clickPublishEvent="clickPublish"
        >
          <template v-slot:overviewPlayerData="{ datas }">
            <div class="cardItem_row_player_wrap">
              <span
                class="cardItem_row"
                :class="playerMode"
                v-for="item in datas"
                :key="item.id"
                @click="
                  goDetail(
                    `playerDetailIndex_${currThemeObj.moduleRouteNameEn}`,
                    item
                  )
                "
              >
                <span class="rankNo" v-text="item.rank"></span>
                <span class="cardItem_row_image cardItem_row_player_image">
                  <img v-if="item.imageUrl" :src="item.imageUrl" />
                  <div v-else class="noImage"></div>
                </span>
                <span class="cardItem_row_center">
                  <span class="cardItem_row_name" v-text="item.shortName"></span>
                  <span
                    class="cardItem_row_teamName"
                    v-text="item.teamName"
                  ></span>
                </span>
                <span class="cardItem_row_val" v-text="item.val"></span>
              </span>
            </div>
          </template>
        </cup_cardList>
      </div>
    </div>
  </div>
</template>

<script>
import { https_package_getDataOverviewByType } from '@api/platfrom_football_api'
import cup_base_data_mixin from '@mixins/cup_base_data'
import cup_cardList from '@components/platfromBase/football/cup_cardList.vue'
import html_seasonMatch from '@components/football/html/HTML_DATAOVERVIEW/seasonMatch.vue'
import html_seasonGoal from '@components/football/html/HTML_DATAOVERVIEW/seasonGoal.vue'
import html_seasonGoalTime from '@components/football/html/HTML_DATAOVERVIEW/seasonGoalTime.vue'
export default {
  name: 'cup_recordDataOverview',
  mixins: [cup_base_data_mixin],
  components: {
    cup_cardList,
    html_seasonMatch,
    html_seasonGoal,
    html_seasonGoalTime,
  },
  data() {
    return {
      floor1_0: null,
      floor1_1: null,
      floor1_2: null,
      templateTypeArr: [5, 6, 7], // 5、最上面；6、球队数据；7、球员数据
      teamTitle: '球队数据',
      teamMode: 'overviewTeamData',
      overview_teamDataList: null,
      playerTitle: '球员数据',
      playerMode: 'overviewPlayerData',
      overview_playerDataList: null,
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      for (let i = 0; i < this.templateTypeArr.length; i++) {
        const templateType = this.templateTypeArr[i]
        await this.getDataOverviewByType({
          templateType,
          sid: this.currSid,
          cid: this.currCid,
        })
      }
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    clickPublish(item) {
      console.debug('点击分享', item)
      this.clickPublicTheme(item.themeItem)
    },
    clickPublicTheme(themeItem) {
      // 分享主题
      let newThemeItem = themeItem
      console.debug('newThemeItem:', newThemeItem)
      if (!newThemeItem.analysisItemName) {
        // 有的主题有analysisItemName，有的没有，比如积分榜，因此处理一下，分享主题到公共播单的接口dataItemName都取这个字段
        newThemeItem.analysisItemName = newThemeItem.title
      }
      window.mixtmtBase_eventBus.$emit('publicThemeDialogEvent', {
        flag: true,
        themeItem: newThemeItem,
        mid: 0,
      })
    },
    async getDataOverviewByType(query) {
      await https_package_getDataOverviewByType(
        this.axiosBaseUrl,
        this.$axios,
        query
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (query.templateType == 5) {
              this.floor1_0 = res.data[0]
              const floor1_1 = res.data[1]
              let list1_1 = floor1_1.statisticsModels.map((model) => {
                return {
                  analysisItemId: model.analysisItemId,
                  key: model.statisticalEn,
                  name: model.name,
                  val: floor1_1.data.dataList[0][model.statisticalEn],
                  valWeb: model.suffix
                    ? floor1_1.data.dataList[0][model.statisticalEn] +
                      model.suffix
                    : floor1_1.data.dataList[0][model.statisticalEn],
                  suffix: model.suffix,
                }
              })
              this.floor1_1 = {
                analysisItemId: floor1_1.analysisItemId,
                title: floor1_1.title,
                json: floor1_1.json,
                seasonOrMatch: floor1_1.seasonOrMatch,
                totalObj:
                  list1_1.length > 0
                    ? list1_1[0]
                    : [
                        {
                          name: '',
                          val: '',
                          valWeb: '',
                          suffix: '',
                        },
                      ],
                otherArr: list1_1.length > 1 ? list1_1.slice(1) : [],
                useScene: floor1_1.useScene,
                analysisItemStyles: floor1_1.analysisItemStyles,
              }
              const floor1_2 = res.data[2]
              let maxVal = 0
              let list1_2 = floor1_2.statisticsModels.map((model) => {
                const val = floor1_2.data.dataList[0][model.statisticalEn]
                if (val > maxVal) {
                  maxVal = val
                }
                return {
                  key: model.statisticalEn,
                  name: model.name,
                  val,
                  suffix: model.suffix,
                }
              })
              if (maxVal > 0) {
                list1_2.forEach((item) => {
                  item.valPer = ((item.val / maxVal) * 4.5).toFixed(2)
                })
              }
              this.floor1_2 = {
                analysisItemId: floor1_2.analysisItemId,
                title: floor1_2.title,
                json: floor1_2.json,
                seasonOrMatch: floor1_2.seasonOrMatch,
                barArr: list1_2.length > 0 ? list1_2 : [],
                useScene: floor1_2.useScene,
                analysisItemStyles: floor1_2.analysisItemStyles,
              }
            } else if (query.templateType == 6) {
              this.overview_teamDataList = res.data
                ? res.data.map((val) => {
                    return {
                      analysisItemId: val.analysisItemId,
                      title: val.title,
                      key: val.templateId,
                      json: val.json,
                      seasonOrMatch: val.seasonOrMatch,
                      analysisItemStyles: val.analysisItemStyles,
                      datas: val.data.dataList.map((item) => ({
                        imageUrl: item.teamLogo,
                        tid: item.teamId,
                        shortName: item.teamName,
                        val: item.num,
                        rank: item.rank,
                      })),
                      useScene: val.useScene,
                    }
                  })
                : []
              // console.debug(this.overview_teamDataList)
            } else if (query.templateType == 7) {
              this.overview_playerDataList = res.data
                ? res.data.map((val) => {
                    return {
                      analysisItemId: val.analysisItemId,
                      title: val.title,
                      key: val.templateId,
                      json: val.json,
                      seasonOrMatch: val.seasonOrMatch,
                      analysisItemStyles: val.analysisItemStyles,
                      datas: val.data.dataList.map((item) => ({
                        imageUrl: item.playerLogo,
                        pid: item.playerId,
                        shortName: item.playerName,
                        val: item.num,
                        rank: item.rank,
                        tid: item.teamId,
                        teamName: item.teamName,
                      })),
                      useScene: val.useScene,
                    }
                  })
                : []
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    goDetail(routeName, item) {
      if (
        routeName == `playerDetailIndex_${this.currThemeObj.moduleRouteNameEn}`
      ) {
        this.pageJump(this.$router, routeName, {
          cid: this.currCid,
          sid: this.currSid,
          tid: item.tid,
          pid: item.pid,
        })
      } else if (
        routeName == `teamDetailIndex_${this.currThemeObj.moduleRouteNameEn}`
      ) {
        this.$localStorage.setItem(
          'mixtmt_teamDetail',
          JSON.stringify({
            teamName: item.shortName,
            teamLogo: item.imageUrl,
            teamId: item.tid,
          })
        )
        this.pageJump(this.$router, routeName, {
          cid: this.currCid,
          sid: this.currSid,
          tid: item.tid,
        })
      } else {
      }
    },
    goMore(routeName) {
      this.pageJump(this.$router, routeName)
    },
  },
}
</script>

<style lang="scss" scoped>
#cup_recordDataOverview {
  .abs_topArea {
    position: absolute;
    top: 8vw;
    left: 0;
    z-index: 10;
    padding: 2vw 0 0 9.722vw;
    width: 100%;
    height: 8.68vw;
    font-size: 3vw;
    line-height: 6.68vw;
    color: var(--mixtmt_whiteColor);
    background-image: var(--mixtmt_detail_banner);
    background-size: 100% auto;
    background-position: center;
    background-repeat: no-repeat;
    object-fit: contain;
  }
  .teamList_area {
    width: 100%;
    padding: 2.083vw 0 3.472vw;
    .teamList_floor1 {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
    }
    .groupData_item {
      padding-top: 2.778vw;
      .group_label {
        position: relative;
        width: 100%;
        height: 3.472vw;
        background-image: var(--mixtmt_scheduleMatchList_dateBg);
        background-size: 100% auto;
        background-position: left top;
        background-repeat: no-repeat;
        .labelTitle {
          position: absolute;
          left: 0;
          top: 0;
          z-index: 2;
          width: 21.55%;
          padding-top: 0.6%;
          font-size: 1.389vw;
          color: var(--mixtmt_whiteColor);
          text-align: center;
          font-weight: bold;
          &.letterSpa {
            letter-spacing: 0.4vw;
          }
        }
        .moreBtn {
          position: absolute;
          right: 0;
          top: 0;
          z-index: 2;
          width: auto;
          font-size: 0.972vw;
          line-height: 1.388vw;
          transition: transform 0.3s linear;
          color: var(--mixtmt_greyColor2);
        }
      }
    }
  }
}
.mixtmt_pc #cup_recordDataOverview,
.mixtmt_ipad #cup_recordDataOverview {
  padding: 8.68vw 0 0;
}
.mixtmt_pc #cup_recordDataOverview {
  padding: 8.68vw 0 0;
  .teamList_area {
    .groupData_item {
      .group_label {
        .moreBtn {
          cursor: pointer;
          &:hover {
            transform: translateX(-0.208vw);
            color: var(--mixtmt_mainColor);
          }
        }
      }
    }
  }
}
</style>
